import React, { useContext } from 'react'
import { AssetsContext } from '../context'
import { Create } from './Create'
import { Form } from './Form'
import { Unlink } from './Unlink'
import { Destroy } from './Destroy'
import { Index } from './Index/index'

export const Views = () => {
  const { state } = useContext(AssetsContext)
  const { screen, error } = state
  const showingIndex = screen === 'index' || screen === 'destroy' || screen === 'unlink'
  return (
    <>
      {error && <p role="alert">{error}</p>}
      {showingIndex && <Index />}
      {screen === 'create' && <Create />}
      {screen === 'destroy' && <Destroy />}
      {screen === 'unlink' && <Unlink />}
      {screen === 'form' && <Form />}
    </>
  )
}
